import {
  CheckIcon,
  NewLoginNotificationIcon,
  NotificationIcon,
  PhoneIcon,
  ShieldIcon,
  TabHistoryIcon,
} from '../../../assets/icons/icons';

const SECURITY_NOTIFICATION_TYPES = new Set([
  'password_change',
  'otp_activated',
  'otp_disabled',
  'otp_recovery_key_updated',
]);

const ACTIVITY_NOTIFICATION_TYPES = new Set([
  'offline_beneficiary_failed',
  'order_new_status',
  'order_status_updated',
]);

const SUCCESS_NOTIFICATION_TYPES = new Set([
  'organization_approved',
]);

export function getNotificationPresentation(type) {
  if (type === 'new_login') {
    return { Icon: NewLoginNotificationIcon, variant: 'login' };
  }

  if (type === 'phone_change') {
    return { Icon: PhoneIcon, variant: 'phone' };
  }

  if (SECURITY_NOTIFICATION_TYPES.has(type)) {
    return { Icon: ShieldIcon, variant: 'security' };
  }

  if (ACTIVITY_NOTIFICATION_TYPES.has(type)) {
    return { Icon: TabHistoryIcon, variant: 'activity' };
  }

  if (SUCCESS_NOTIFICATION_TYPES.has(type)) {
    return { Icon: CheckIcon, variant: 'success' };
  }

  return { Icon: NotificationIcon, variant: 'notification' };
}
